import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBus"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3V7H1V8.5H3V12.5H21V8.5H23V7H21V3H3ZM9 6H15V4.5H9V6Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V14H21V21H15.5V19H8.5V21H3ZM6 17H9V15.5H6V17ZM18 17H15V15.5H18V17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBus;
